import { getMainDefinition } from '@apollo/client/utilities';

export function isWebSocketSubscription({ query }): boolean {
    const mainDefinition = getMainDefinition(query);

    if (mainDefinition.kind === 'OperationDefinition') {
        return mainDefinition.operation === 'subscription';
    }

    return false;
}
